import React from 'react';
import { SignOutPage } from '~src/authentication/components/SignOutPage';
import { DefaultServerTitleWrapper } from './DefaultServerTitleWrapper';

export const SignedOutProvider = (): JSX.Element => {
  return (
    <DefaultServerTitleWrapper>
      <div>
        <SignOutPage />
      </div>
    </DefaultServerTitleWrapper>
  );
};

export const SiteSamlSignedOutProvider = (): JSX.Element => {
  return (
    <DefaultServerTitleWrapper>
      <div>
        <SignOutPage />
      </div>
    </DefaultServerTitleWrapper>
  );
};
